import type { ReportResources } from './en-US.js';

export const ja: ReportResources = {
  nav: {
    report: '自分の週報',
    history: '履歴',
    team: 'チーム',
  },
  report: {
    title: '週報',
    titleOf: '{{name}} さんの週報',
    previousWeek: '前の週',
    nextWeek: '次の週',
    thisWeek: '今週',
    pickWeek: '週',
    planThisWeek: '今週の予定',
    days: '日報',
    planNextWeek: '来週の予定',
    editableUntil: '{{deadline}} まで編集できます',
    lockedSince: '{{deadline}} に締め切られました',
    confirmedBy: '{{name}} が確認済み（{{time}}）',
    notWritten: 'まだ記入されていません。',
    inherited: '先週の「来週の予定」を引き継いでいます。編集して保存してください。',
    save: '保存',
    saved: '保存しました。',
    unsaved: '未保存の変更があります',
    draftFound: '{{time}} の未保存の変更がこの端末に残っています。',
    restoreDraft: '復元',
    discardDraft: '破棄',
    conflict:
      'この週報は別の場所で変更されました。再読み込みしてください。入力内容は下書きとして残ります。',
    reload: '再読み込み',
    leaveTitle: '保存せずに移動しますか？',
    leave: '移動する',
    stay: 'とどまる',
    workTimesUnavailable: '勤務時間を取得できません。',
    modified: '修正あり',
    history: '履歴',
  },
  editor: {
    bold: '太字',
    italic: '斜体',
    underline: '下線',
    strike: '取り消し線',
    bulletList: '箇条書き',
    orderedList: '番号付きリスト',
    link: 'リンク',
    linkAddress: 'リンク先（https://… または mailto:…）',
    invalidLink: 'https://、http:// または mailto: で始まるアドレスを入力してください。',
    removeLink: 'リンクを解除',
    clearFormatting: '書式をクリア',
    undo: '元に戻す',
    redo: 'やり直す',
  },
  revisions: {
    title: '変更履歴',
    empty: '変更はまだありません。',
    inherited: '引き継ぎ',
    before: '変更前',
    after: '変更後',
    planThisWeek: '今週の予定',
    planNextWeek: '来週の予定',
    day: '日報 {{date}}',
  },
  history: {
    title: '履歴',
    week: '週',
    status: '状態',
    deadline: '締め切り',
    confirmedAt: '確認日時',
    empty: '週報はまだありません。',
  },
  team: {
    group: 'グループ',
    allGroups: 'すべてのグループ',
    title: 'チームの週報',
    member: 'メンバー',
    weeks: '週数',
    unconfirmedOnly: '未確認のみ',
    missing: '未記入',
    locked: '締め切り後',
    empty: 'メンバーがいません。',
  },
  audit: {
    title: '監査ログ',
    time: '日時',
    actor: '実行者',
    action: '操作',
    target: '対象',
    system: 'システム',
    actions: {
      ReportConfirmed: '週報の確認',
      ReportUnconfirmed: '確認の取り消し',
      LocalAdminGranted: '管理者の追加',
      LocalAdminRevoked: '管理者の削除',
    },
  },
};
